import { setTerm } from './helpers';

export const setIsByHomeowner = setTerm('is_by_homeowner');
